import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('bulk_ops_select_all_beyond_experiment', 'isEnabled', false);
	},
};
